import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import React from 'react';
interface CompanyCardProps {
  href: string;
  logo: string | React.ReactNode;
  name: string;
}
export const CompanyCard: React.FC<CompanyCardProps> = t0 => {
  const $ = _c(16);
  const {
    href,
    logo,
    name
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute -right-4 -top-4 size-24 rounded-full bg-primary/10 transition-all duration-300 group-hover:scale-110" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== logo || $[2] !== name) {
    t2 = typeof logo === "string" && /\.(jpg|jpeg|png|gif|svg|webp|ico)$/i.test(logo) ? <Image src={logo} alt={`${name} logo`} width={48} height={48} /> : typeof logo === "string" ? <span className="text-3xl font-semibold">{logo}</span> : logo;
    $[1] = logo;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="mx-auto mb-6 flex size-20 items-center justify-center rounded-2xl bg-primary text-white shadow-lg">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== name) {
    t4 = <h3 className="mb-3 text-2xl font-semibold text-textPrimary transition-colors group-hover:text-primary">{name}</h3>;
    $[6] = name;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span>Visit website</span>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="inline-flex items-center font-semibold text-primary">{t5}<svg className="ml-2 size-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4) {
    t7 = <div className="relative overflow-hidden rounded-2xl border border-ds-border-subtle bg-background-light p-8 transition-all duration-300 hover:-translate-y-2 hover:border-ds-border-hover hover:bg-background-light">{t1}<div className="relative text-center">{t3}{t4}{t6}</div></div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== href || $[14] !== t7) {
    t8 = <a href={href} target="_blank" rel="noopener noreferrer" className="group">{t7}</a>;
    $[13] = href;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};